import { action } from 'typesafe-actions';
import {
  Types,
  IFabricationPurchaseOrderState,
  EFabricationOrderSteps
} from './types';
import { FABRICATION_ORDER_INITIAL_STATE } from '.';

export const updateFabricationPurchaseOrderSettings = (
  fabricationPurchaseOrderState: IFabricationPurchaseOrderState
) =>
  action(Types.UPDATE_FABRICATION_PURCHASE_ORDER_SETTINGS, {
    fabricationPurchaseOrderState
  });

export const updateFabricationStep = (
  fabricationOrderStep: EFabricationOrderSteps
) => action(Types.UPDATE_FABRICATION_STEP, { fabricationOrderStep });

export const sendFabricationPurchaseOrder = (
  fabricationPurchaseOrderState: IFabricationPurchaseOrderState
) => action(Types.FINISH_ORDER, { fabricationPurchaseOrderState });
export const sendFabricationPurchaseOrderSuccess = (createdOrderId: number) =>
  action(Types.FINISH_ORDER_SUCCESS, { createdOrderId });
export const sendFabricationPurchaseOrderFailure = (error: unknown) =>
  action(Types.FINISH_ORDER_FAILURE, { error });

export const cleanFabricationPurchaseOrderSettings = (
  fabricationPurchaseOrderState = FABRICATION_ORDER_INITIAL_STATE
) =>
  action(Types.CLEAN_FABRICATION_PURCHASE_ORDER_SETTINGS, {
    fabricationPurchaseOrderState
  });
